import React from "react";
import { Route, Routes } from "react-router-dom";
import AuthView from "../Auth/AuthView";

const UnAuthedRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthView />} />
        </Routes>
    );
};
export default UnAuthedRoutes;
